import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ delay = 600 }) {
    const { pathname } = useLocation();

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "instant" });
        }, delay);

        return () => clearTimeout(timer);
    }, [pathname, delay]);

    return null;
}
